import Vue from "vue";
import request from "./config/http.js";
import params from "./config/params.js";
import HTTP from "./config/api.js";
import global from "@/core/global/global.js";
import { jsonp } from 'vue-jsonp'

const sys = "/tsg-admin/sys";

const getDetailUrl = sys + "/Editing/getDetail"; //采编名片内容
const shareDetailUrl = "/detail/getDetail"; //分享采编名片内容
const queryFirstAuditListUrl = "/sys/review/queryFirstAuditList"; //待初审列表
const queryTemplateStatusUrl = "/sys/review/queryTemplateStatus"; //初审回显审核编辑的稿件
const addFirstAuditRecordingUrl = "/sys/review/addFirstAuditRecording"; //提交初审意见信息
const FirstAuditListForFinishUrl = "/sys/review/queryAllFirstAuditList"; //初审完成列表

const templateListUrl = "/sys/reviewTemplate/queryReviewTemplate"; //审核模板列表
const addTemplateUrl = "/sys/reviewTemplate/addReviewTemplate"; //添加审核模板
const delTemplateUrl = "/sys/reviewTemplate/delReviewTemplate"; //删除审核模板
const reviewTemplateDetailUrl = "/sys/reviewTemplate/reviewTemplateDetail"; //查看审核模板

const compilationListUrl = "/sys/articleEmploy/articleCompilationList"; //采编 查询看板列表
const compilationDetialUrl = "/sys/articleEmploy/queryCompilationDetail"; //采编 根据稿件id查询稿件详情
const compilationStatusUrl = "/sys/articleEmploy/updateCompilationStatus"; //采编 看版退回，更改稿件状态
const compilationStatusByIdUrl =
  "/sys/articleEmploy/updateCompilationStatusById"; //采编 看版确认，更改稿件状态

const finalArticleListUrl = "/sys/article/queryAwaitFinalArticle"; //上传终稿列表
const finalArticleInfoUrl = "/sys/article/updateFinalArticleInfo"; //录入

const queryArticleDetailUrl = "/sys/article/queryArticleById"; //稿件详情
const url = "/sys/finalAudit"; //终审
const tabNumber = "/sys/review/auditStatistics"; //tab标签显示数据
const caibianInvoice = "/review/editInvoiceList"; // 采编发票信息
const returnBill = "/invoice/returnBill"; // 发票撤回

const userBlives = "/tsg-admin/sys/journal/editingList"; //采编操作日志

//const userBlives = '/tsg-admin/sys/periodical/perList'

//http://47.93.50.49:8093/sys/journal/queryUser?periodicalId=1310096144586461184&time=1623115085897
const apis = {
  // 采编稿件查询
  getEditingList(data) {
    return request({
      url: sys + "/Editing/list",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },

  cardGetDetail(data) {
    return request({
      url: sys + "/edit_card/getDetail",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },

  saveConfig(data) {
    return request({
      url: sys + "/edit_card/saveConfig",
      method: "post",
      data,
      jsonString: JSON.stringify(data),
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },

  //systemMsg/delMsg投审稿后台删除系统消息
  //systemMsg/getMsgList投审稿后台系统消息列表
  //systemMsg/send投审稿后台发送系统消息
  delMsg(data) {
    return HTTP.get(
      global.global.url3 + "/api/zw-chat/systemMsg/delMsg",
      data,
      false
    );
  },
  getMsgList(data) {
    return request({
      url: "/api/zw-chat/systemMsg/getMsgList",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  //http://47.93.50.49:8092/tsg-author/web/submit/queryArticleInfoById?articleId=1478169540922839040&time=1641882320649
  //http://47.93.50.49:5052/web/submit/queryEditingByUserId?userId=1306857331082006528&time=1641882357339

  // queryEditingByUserId(params) { //责任采编
  //   return request({
  //     url: "/apis/tsg-author/web/submit/queryEditingByUserId",
  //     method: 'get',
  //     params: params,

  //   }).then((resault) => {
  //     return Promise.resolve(resault.data)
  //   })
  // },

  send(data) {
    return HTTP.postFormData(
      global.global.url3 + "/api/zw-chat/systemMsg/send",
      data,
      false
    );
  },

  //发票撤回
  returnBill(data) {
    return request({
      url: sys + returnBill,
      method: "post",
      data: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  //请求采编发票列表
  editInvoiceList(data) {
    return request({
      url: sys + caibianInvoice,
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  //请求采编绩效列表
  queryPerformanceList(path, data) {
    return request({
      url: sys + path,
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  //获取待终审列表
  queryFinalAuditList(data) {
    return request({
      url: url + "/queryFinalAuditList",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  //复审意见查看
  queryReauditResult(data) {
    return request({
      url: url + "/queryReauditResult",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  //跳转到终审页面回显信息
  gotoCheckAuditPage(data) {
    return request({
      url: url + "/gotoCheckAuditPage",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  //终审，提交审核意见
  reaudit(data) {
    return request({
      url: url + "/reaudit",
      method: "post",
      data: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  //终审完成列表
  queryFinalAuditListForFinish(data) {
    return request({
      url: url + "/queryFinalAuditListForFinish",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  //获取待初审列表
  queryFirstAuditList(data) {
    return request({
      url: queryFirstAuditListUrl,
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },

  //采编名片内容
  getDetail(data) {
    return request({
      url: getDetailUrl,
      method: "get",
      isToken: true,
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },

  //分享采编名片内容
  shareDetail(data) {
    return request({
      url: shareDetailUrl,
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },

  //初审回显审核编辑的稿件
  queryTemplateStatus(data) {
    return request({
      url: queryTemplateStatusUrl,
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },

  //提交初审意见信息
  addFirstAuditRecording(data) {
    return request({
      url: addFirstAuditRecordingUrl,
      method: "post",
      data: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },

  //待初审列表
  FirstAuditListForFinish(data) {
    return request({
      url: FirstAuditListForFinishUrl,
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },

  //审核模板列表
  templateList(data) {
    return request({
      url: templateListUrl,
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },

  //添加审核模板
  addTemplate(data) {
    return request({
      url: addTemplateUrl,
      method: "post",
      data: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },

  //删除审核模板
  delTemplate(data) {
    return request({
      url: delTemplateUrl,
      method: "delete",
      data: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },

  //查询看板列表
  compilationList(data) {
    return request({
      url: compilationListUrl,
      method: "post",
      data: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },

  //根据稿件id查询稿件详情
  compilationDetial(data) {
    return request({
      url: compilationDetialUrl,
      method: "post",
      data: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },

  //看版退回
  compilationStatus(data) {
    return request({
      url: compilationStatusUrl,
      method: "post",
      data: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },

  //看版确认
  compilationStatusById(data) {
    return request({
      url: compilationStatusByIdUrl,
      method: "post",
      data: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },

  //上传终稿列表
  finalArticleList(data) {
    return request({
      url: finalArticleListUrl,
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },

  //录入
  finalArticleInfo(data) {
    return request({
      url: finalArticleInfoUrl,
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },

  //查看审核模板
  reviewTemplateDetail(data) {
    return request({
      url: reviewTemplateDetailUrl,
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },

  //稿件详情
  queryArticleDetail(data) {
    return request({
      url: queryArticleDetailUrl,
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  //退稿-李小红
  applyRevocationArticle(data) {
    return request({
      url: "/sys/article/applyRevocationArticle",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  //tab标签显示数量
  tabNumberFun(data) {
    return request({
      url: tabNumber,
      method: "get",
      isToken: true,
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  //tab标签显示数量待终审
  queryFinalAuditListCount(data) {
    return request({
      url: "/sys/finalAudit/queryFinalAuditListCount",
      method: "get",
      isToken: true,
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  //tab标签显示数量终审完成
  queryFinalAuditListForFinishCount(data) {
    return request({
      url: "/sys/finalAudit/queryFinalAuditListForFinishCount",
      method: "get",
      isToken: true,
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },

  //用户采编日志
  userlist(data) {
    return request({
      url: userBlives,
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  ///用户id   sys/journal/queryUser
  usersId(data) {
    return request({
      url: "/tsg-admin/sys/journal/queryUser",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  //稿件查询日志  sys/journal/queryUser
  gitList(data) {
    return request({
      url: "/tsg-admin/sys/journal/articleList",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  //审核退回
  finalToReauditResult(data) {
    return request({
      url: "/tsg-admin/sys/finalAudit/finalToReauditResult",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  //审核退回返回上一环节  (除终审以及复审完成)
  reAudit(data) {
    return request({
      url: "/tsg-admin/sys/finalAudit/reAudit",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  //审核退回返回上一环节  (终审以及复审完成)
  finalToReauditResult(data) {
    return request({
      url: "/tsg-admin/sys/finalAudit/finalToReauditResult",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  //审核修改稿件状态
  updStatus(data) {
    return request({
      url: "/tsg-admin/sys/finalAudit/updStatus",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  //修改稿件状态审核状态
  getAudits(data) {
    return request({
      url: "/tsg-admin/sys/finalAudit/getAudits",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  //加密方式
  getPk(data) {
    return request({
      url: "/api/zw-user/getPk",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  // ip获取
  getUserIpConfig() {
    return new Promise((resolve, reject) => {
      jsonp(`https://apis.map.qq.com/ws/location/v1/ip?key=OWOBZ-6CZKQ-44B5T-2WQIO-YUTJ7-5TFJO`, {
        output: 'jsonp',
      }).then(resp => {
        resolve(resp)
      }).catch(err => {
        console.log(err);
      })
    })
  },
  //采编名片管理
  //采编名片管理添加
  addEdit(data) {
    return HTTP.postFormData(
      global.global.url3 + "/api/zw-chat/editing_card/add",
      data,
      false
    );
  },
  //采编名片管理修改
  updEdit(data) {
    return HTTP.postFormData(
      global.global.url3 + "/api/zw-chat/editing_card/upd",
      data,
      false
    );
  },
  //采编名片停用/启用
  enable(data) {
    return HTTP.json(
      global.global.url3 + "/api/zw-chat/editing_card/enable",
      data,
      false
    );
  },
  /*推荐文献分页*/
  chaxuTui(params) {
    return HTTP.postFormData(
      global.global.url3 + "/api/zw-information/adminInfo/getRecommend",
      params,
      false
    );
    
  },
  // 初审/复审审核退修，添加推荐文献，查询中文知识网ES接口 v3.0.5接口修改为 /api/zw-elasticsearch/search/article
  cnESArticleList(data) {
    return HTTP.postFormData(
      global.global.url3 + "/api/zw-elasticsearch/search/article",
      data,
      false
    )
  },

  //终版存档已完成zw-information/articleWithTsg/getTsgArticleList
  updateTsgArticle(data) {
    return HTTP.postFormData(
      global.global.url3 +
        "/api/zw-information/articleWithTsg/nf/updateTsgArticle",
      data,
      false
    );
  },
  //终版存档添加作者未注册用户http://47.93.50.49:5052/api/zw-information/articleInfo/websave
  articleInfoWeb(data) {
    return HTTP.postFormData(
      global.global.url3 + "/api/zw-information/articleInfo/websave",
      data,
      false
    );
  },

  // 回显/searchUser/nf/findAuthorInfoByNameAndCompany
  getEcho(data) {
    return HTTP.get(
      global.global.url3 + "/api/zw-information/articleInfo/getDetails",
      data,
      false
    );
  },
  findAuthorInfoByNameAndCompany(data) {
    return HTTP.post(
      global.global.url3 +
        "/api/zw-user/searchUser/nf/findAuthorInfoByNameAndCompany",
      data,
      false
    );
  },
  //zw-information/articleInfo/deleteArticle
  // deleteArticle(data) { //终版存档删除
  //   return request({
  //     url: '/api/zw-information/articleInfo/deleteArticle',
  //     method: 'post',
  //     params: data
  //   }).then((resault) => {
  //     return Promise.resolve(resault.data)
  //   })
  // },
  deleteArticle(data) {
    return HTTP.postFormData(
      global.global.url3 + "/api/zw-information/articleInfo/deleteArticle",
      data,
      false
    );
  },

  //查询第一作者：http://47.93.50.49:5052/api/zw-user/searchUser/nf/findAuthorInfoByNameAndCompany

  // updateTsgArticle(data) {
  //   return request({
  //     url: '/api/zw-information/articleWithTsg/updateTsgArticle',
  //     method: 'post',
  //     params: data,
  //     // jsonString: true,
  //   }).then((resault) => {
  //     return Promise.resolve(resault.data)
  //   })
  // },

  //采编名片列表
  pageEdit(data) {
    return request({
      url: "/api/zw-chat/editing_card/page",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  //采编下拉
  editList(data) {
    return request({
      url: "/api/zw-chat/editing_card/editList",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  //采编删除
  delData(data) {
    return HTTP.postFormData(
      global.global.url3 + "/api/zw-chat/editing_card/del",
      data,
      false
    );
  },
  //统计
  //采编统计
  noDifference(data) {
    return request({
      url: "/api/zw-chat/statistics/noDifference",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  // 公告
  // 公告列表
  queryPublicationList(data) {
    return request({
      url: "/tsg-admin/sys/publication/queryPublicationList",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  //添加公告
  savePublication(data) {
    return request({
      url: "/tsg-admin/sys/publication/savePublication",
      method: "post",
      data: data,
      jsonString: true,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  //修改公告
  updatePublication(data) {
    return request({
      url: "/tsg-admin/sys/publication/updatePublication",
      method: "post",
      data: data,
      jsonString: true,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },

  //删除公告
  deletePublication(data) {
    return request({
      url: "/tsg-admin/sys/publication/deletePublication",
      method: "post",
      data: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  //公告置顶
  topping(data) {
    return request({
      url: "/tsg-admin/sys/publication/topping",
      method: "get",
      params: data,
      //jsonString: true,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  //公告取消置顶
  cancelTopping(data) {
    return request({
      url: "/tsg-admin/sys/publication/cancelTopping",
      method: "get",
      params: data,
      //jsonString: true,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  //公告置顶排序
  sortTopping(data) {
    return request({
      url: "/tsg-admin/sys/publication/sortTopping",
      method: "get",
      params: data,
      //jsonString: true,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  //投诉列表
  complaintList(data) {
    return request({
      url: "/tsg-admin/sys/publication/complaintList",
      method: "get",
      params: data,
      //jsonString: true,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  //投诉意见处理
  complaintHandle(data) {
    return request({
      url: "/tsg-admin/sys/publication/complaintHandle",
      method: "get",
      params: data,
      //jsonString: true,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  //终版存档已完成zw-information/articleWithTsg/getTsgArticleList
  getTsgArticleList(data) {
    return request({
      url: "/api/zw-information/articleWithTsg/nf/getTsgArticleList",
      method: "get",
      params: data,
      //jsonString: true,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  hasFile(data) {
    return request({
      url: "/api/zw-public/web/common/hasFileNoToken",
      method: "get",
      params: data,
      //jsonString: true,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  // http://47.93.50.49:5052/api/zw-public/web/common/readPDFPicFile2?articleType=0&articleId=1458725130472656896
  readPDFPi(data) {
    return request({
      url: "/api/zw-public/web/common/readPDFPicFile2NoToken",
      method: "get",
      params: data,
      //jsonString: true,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
};

export default apis;



// WEBPACK FOOTER //
// ./src/core/api/caibian.serve.js